module.exports = __webpack_public_path__ + "static/media/schufa_icon.013f5cbe.svg";